import { AxiosResponse } from 'utils/interface';
import { Timer, TimeEntry } from './types';

const toNumber = (value: unknown): number => {
  const parsed = typeof value === 'string' ? parseInt(value, 10) : Number(value);
  return Number.isFinite(parsed) ? parsed : 0;
};

export const unwrap = <T = any>(res: AxiosResponse): T => res?.data?.data ?? res?.data;

export const normalizeTimer = (raw: any): Timer => ({
  ...raw,
  uuid: raw.uuid,
  status: raw.status,
  source: raw.source,
  source_uuid: raw.source_uuid,
  source_title: raw.source_title,
  date: raw.date,
  minutes: toNumber(raw.minutes),
  live_minutes: raw.live_minutes != null ? toNumber(raw.live_minutes) : undefined,
  started_at: raw.started_at ?? null,
  user_uuid: raw.user_uuid,
  user_name: raw.user_name,
  comment: raw.comment,
  billable: raw.billable,
  ref_token: raw.ref_token,
});

export const normalizeEntry = (raw: any): TimeEntry => ({
  ...raw,
  uuid: raw.uuid,
  billable: raw.billable,
  comment: raw.comment,
  minutes: toNumber(raw.minutes),
  date: raw.date,
  source: raw.source,
  source_uuid: raw.source_uuid,
  source_title: raw.source_title,
  user_uuid: raw.user_uuid,
  user_name: raw.user_name,
});

export const toTimer = (res: AxiosResponse): Timer => normalizeTimer(unwrap(res));

export const toTimerList = (res: AxiosResponse): Timer[] => {
  const list = unwrap<any[]>(res);
  return Array.isArray(list) ? list.map(normalizeTimer) : [];
};

export const toEntry = (res: AxiosResponse): TimeEntry => normalizeEntry(unwrap(res));
